module.exports = __webpack_public_path__ + "static/img/30-box.f4cdef3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/30-box.png
// module id = c5cO
// module chunks = 0